import _ from 'underscore'
import $ from 'jquery'

import { localize } from 'util/localize'
import { postRenderImages } from 'util/twistle'
import { renderTemplate } from 'util/template_renderer'
import ContactListItemView from 'app/views/contact_list_item_view'
import Contact from 'app/models/contact'

(function($) {
    $.widget("ui.twistle_search_autocomplete", {
        // default options
        options: {
            source: "/search/Suggest",
            foruser: "self",
            max_people_results: "10",
            max_term_results: "10",
            position: {
                my: "left top",
                at: "left+2 bottom+4",
                collision: "none"
            },
            location: "dashboard"
        },

        _create: function() {
            var self = this;
            let paramData = {
                placeholder: localize(
                    "search",
                    "Search by keyword, ID, contact info..."
                )
            };
            var searchField = renderTemplate('search_field_template', paramData);
            this.element.html(searchField);

            var searchbox = this.element.find(".searchbox");

            var searchcancel = this.element.find(".search_cancel");

            searchcancel.on("click",function() {
                self.reset();
            }).hide();

            let searchXhr = undefined;

            searchbox.autocomplete({
                delay: 220,
                source: function (request, response) {
                    var data = { term: request.term, org_ids: App.account.getDefaultOrg().id };
                    if(searchXhr){
                        searchXhr.abort();
                    }
                    searchXhr = $.ajax({
                        url: "/search/Suggest",
                        data: data,
                        dataType: "json",
                        success: function(suggestion) {
                            suggestion.accounts.sort((a, b) => b.score - a.score);
                            response(suggestion);
                            searchXhr = undefined;
                        },
                        error: function() {
                            response([]);
                            searchXhr = undefined;
                        }
                    });
                },
                minLength: 1,
                minChars: 1,
                position: this.options.position,
                autoFocus: false,
                select: function(event, ui) {
                    self._trigger("itemSelected", event, ui);
                    if (ui.item && ui.item.type === "account") {
                        App.trigger("app:view_contact", new Contact({
                            username: ui.item.username
                        }), true);
                    }
                    else if (ui.item && ui.item.type === "term") {
                        searchbox.val(ui.item.term);
                        App.trigger("app:view_search", ui.item.term);
                    }
                    else {
                        App.trigger("app:view_search", searchbox.val());
                    }

                    return false; // prevent updating of the input box - we handle it manually above
                },
                focus: function(event, ui) {
                    return false; // prevent updating of the input box on focus of an AC item too
                }
            });

            searchbox.data("ui-autocomplete")._resizeMenu = function() {
                var ul = this.menu.element;
                ul.outerWidth(self.options.width);
            };

            // Renders the search result dropdown
            searchbox.data("ui-autocomplete")._renderMenu = function(ul, items) {
                // Patients
                var patients = _.filter(items.accounts, function(u) {
                    return u.primaryroles.indexOf("p") != -1;
                });
                self._appendContactsWithTitleToList(patients,
                    localize("SideNavigation-patients", "Patients"),
                    ul);

                // Staff
                var staff = _.filter(items.accounts, function(u) {
                    return u.primaryroles.indexOf("c") != -1;
                });
                self._appendContactsWithTitleToList(staff,
                    localize("SideNavigation-team", "Team"),
                    ul);

                // Conversations
                if (items.terms.length > 0) {
                    var $convHeader = $("<li class='search-header'>" +
                    localize("SideNavigation-conversations", "Conversations") +
                    "</li>").data("ui-autocomplete-item",{});
                    ul.append($convHeader);
                    $(items.terms).each(function(idx, val) {
                        val.type = "term";
                        var $item = $("<li class='autoterm tws-search-result-item search-result-item-conversation'></li>").data("ui-autocomplete-item", val);
                        if (val.tag){
                            $item.html("<a class='conversation_tags'><div class='conversation_tag'>" + val.term + "</div></a>");
                        }
                        else{
                            $item.html("<a>" + val.term + "</a>");
                        }
                        $item.appendTo(ul);
                    });

                    ul.find(".conversation_tag").randomTagColor();
                }

                var term = searchbox.val();
                $("<li class='autosearchheader' aria-label='Perform full text search'></li>")
                    .data("item.autocomplete", "Search for " + term)
                    .append($("<a></a>", {id: "autochars"}).text(
                        localize("UIHelpers-seachFor", "Search for") +
                        ' "' + term + '"'))
                    .appendTo(ul);

                ul.addClass("twistle_search_autocomplete");

                self.element.find(".search_cancel").show();

                postRenderImages(ul);

                if (self.options.$container) {
                    self.options.$container.show().append(ul);
                }
            };

            searchbox.data("ui-autocomplete")._normalize = function(items) {
                return items;
            };

            searchbox.keydown(function(e) {
                var code = e.keyCode || e.which;
                if (code === 13 && searchbox.val().length > 0) {
                    var val = searchbox.val();
                    var xhrrequest = searchbox.data('jqXHR');
                    if (xhrrequest) {
                        xhrrequest.abort();
                    }
                    searchbox.data('cancelXhr',true);
                    searchbox.autocomplete("close");
                    self.reset();
                    setTimeout(function(){
                        App.trigger("app:view_search", val);
                    }, 50);
                }
            });

            self.file_info = [];
        },

        reset: function() {
            var searchbox = this.element.find(".searchbox");
            var searchcancel = this.element.find(".search_cancel");

            searchbox.autocomplete("close").val("");
            searchcancel.hide();
            if (this.options.$container) {
                this.options.$container.hide();
            }
        },

        destroy: function() {
            $.Widget.prototype.destroy.apply(this, arguments);
        },

        _appendContactsWithTitleToList: function(contacts, title, list) {
            if (contacts.length == 0) {
                return;
            }

            var self = this;

            var $header = $("<li class='search-header'>" + title + "</li>").data("ui-autocomplete-item",{});
            list.append($header);

            contacts.forEach(function(val) { // val is a bog-standard JS object.
                val.type = "account";
                val.thumbsize = "smthm";
                const contactModel = new Contact(val);
                var contactListItemView = new ContactListItemView({
                    model: contactModel,
                    searchResultMode: true
                });
                $("<li class='tws-search-result-item'></li>")
                    .append(contactListItemView.$el)
                    .data("ui-autocomplete-item", val)
                    .appendTo(list);
            });
        }
    });
}($));
